<template>
  <div>
    <!-- ●●●上部メニュー●●● -->
    <Header :type="menu_type" :title="title" />
    <b-container fluid class="px-4 py-4 min-vh-85">
      <b-row class="d-flex justify-content-center mb-2">
        <b-col>
          <b-media>
            <b-media-body class="pb-3">
              <div class="d-flex justify-content-between">
                <h5 class="text-secondary m-0"><span class="oi oi-brush"></span>
                  <strong> 電子書類保守入力</strong>
                  <b-form-text class="text-muted d-inline-flex">(編集途中の情報は保持されません。編集が終わりましたら、必ず[保存]ボタンを押してください)</b-form-text>
                </h5>
                <b-button pill v-b-tooltip.hover.noninteractive.bottom="'電子書類保守一覧に戻る'" @click="clickBack" class="btn-cancel m-0">
                  <span class="oi oi-circle-x"></span> キャンセル
                </b-button>
              </div>
            </b-media-body>
          </b-media>
          <div class="main-card mb-3 card">
            <b-card-header v-if="getMessageFlg==true">
              <b-alert show variant="warning" class="mt-2" v-if="alertWarning.length">
                <ul v-for="(error,index) in alertWarning" :key="index" style="list-style: none;">
                  <li>{{error}}</li>
                </ul>
              </b-alert>
              <b-alert show variant="danger" class="mt-2" v-if="alertDanger.length">
                <ul v-for="(error,index) in alertDanger" :key="index" style="list-style: none;">
                  <li>{{error}}</li>
                </ul>
              </b-alert>
            </b-card-header>
            <div class="card-body">
              <validation-observer ref="observer">
                <b-form @submit.prevent="clearAlert(); saveData();" id="InputForm" class="form-horizontal">
                  <b-row>
                    <b-col sm="4" class="px-1">
                      <!-- 電子書類区分 -->
                      <validation-provider name="electronicDocumentsClass" rules="required|numeric|between:1,9999" v-slot="{ classes, errors }">
                        <div :class="classes">
                          <label for="electronicDocumentsClass" class="form-label" v-b-tooltip.hover.noninteractive title="必須項目です。数値を入力してください。">電子書類区分 <span class="px-1 oi oi-flag"/></label>
                          <b-input-group>
                            <input type="text" id="electronicDocumentsClass" class="form-control" v-model="electronicDocumentsClass" maxlength="4">
                            <b-button pill size="sm" variant="success" v-b-tooltip.hover.noninteractive title="電子書類区分に未登録の中で最低の数値を設定します。" @click="clearAlert(); setElectronicDocumentsClass();" class="mr-1">
                              <span class="oi oi-pencil"></span> 区分値設定
                            </b-button>
                          </b-input-group>
                          <span id="error" v-if="errors[0]">{{ errors[0] }}</span>
                        </div>
                      </validation-provider>
                    </b-col>
                    <b-col sm="2" class="px-1">
                      <!-- 表示順 -->
                      <validation-provider name="sort" rules="required|numeric|between:1,9999" v-slot="{ classes, errors }">
                        <div :class="classes">
                          <label for="sort" class="form-label" v-b-tooltip.hover.noninteractive title="必須項目です。数値を入力してください。">表示順 <span class="px-1 oi oi-flag"/></label>
                          <input type="text" id="sort" class="form-control" v-model="sort" maxlength="4">
                          <span id="error" v-if="errors[0]">{{ errors[0] }}</span>
                        </div>
                      </validation-provider>
                    </b-col>
                  </b-row>
                  <b-row class="mt-2">
                    <b-col lg="12" class="px-1">
                      <!-- 電子書類名 -->
                      <validation-provider name="electronicDocumentsName" rules="required" v-slot="{ classes, errors }">
                        <div :class="classes">
                          <label for="electronicDocumentsName" class="form-label" v-b-tooltip.hover.noninteractive title="必須項目です。">電子書類名 <span class="px-1 oi oi-flag"/></label>
                          <input type="text" id="electronicDocumentsName" class="form-control" v-model="electronicDocumentsName" maxlength="40">
                          <span id="error" v-if="errors[0]">{{ errors[0] }}</span>
                        </div>
                      </validation-provider>
                    </b-col>
                  </b-row>
                </b-form>
              </validation-observer>
            </div>
            <!-- 保存ボタン -->
            <b-card-footer>
              <b-row class="justify-content-md-center pb-4">
                <b-col lg="2">
                  <b-button  class="mr-2" pill block variant="success" type="submit" form="InputForm">
                    <span class="oi oi-circle-check"></span> 保存
                  </b-button>
                </b-col>
              </b-row>
            </b-card-footer>
          </div>
        </b-col>
      </b-row>
    </b-container>
    <!-- ●●●フッター●●● -->
    <Footer />
  </div>
</template>
<script>
import Header from '@/components/navigation/header.vue';
import Footer from '@/components/navigation/footer.vue';
import { init, addOperationLogs, CreateColRow, escapeQuote, CreateInsertSql, executeTransactSqlList, isSystemEditable, executeSelectSql } from '@/assets/js/common.js';
import { DISP_MESSAGES } from '@/assets/js/messages';

const MODULE_NAME = 'save-documents-maintenance-input';

export default {
  name: 'SAVE-DOCUMENTS-MAINTENANCE-INPUT',
  // コンポーネント
  components: {
    Header,
    Footer,
  },
  // データ
  data() {
    return {
      // ヘッダ
      menu_type: 'user',
      title: '電子書類保守入力',
      // アラート
      alertWarning: [],
      alertDanger: [],
      // 入力情報
      electronicDocumentsClass: '',
      electronicDocumentsName: '',
      sort: '',
      // ログイン情報
      loginId: this.$store.getters.user.username,
    }
  },
  // マウント
  async mounted() {
    init(); // common.jsにて初期化処理
    this.$store.commit('setLoading', false);
  },
  computed: {
    // メッセージがあるかどうかの返却
    getMessageFlg: function() {
      if (this.alertWarning.length > 0 ||
      this.alertDanger.length > 0) {
        return true;
      } else {
        return false;
      }
    },
  },
  methods: {
    // 画面のアラートをクリア
    clearAlert: function() {
      this.alertWarning = [];
      this.alertDanger = [];
    },
    // キャンセルボタン押下時
    async clickBack(){
      // 電子書類保守一覧画面へ遷移
      this.$router.push({name: 'SAVE-DOCUMENTS-MAINTENANCE-LIST'});
    },
    // 保存ボタンの押下
    async saveData() {
      const functionName = 'saveData';
      // veeValidateのvalidationObserverが持つ情報をvalidate()で全てバリデーション実行
      const observer = this.$refs.observer;
      const success = await observer.validate();

      // バリデーションが全て通れば、保存処理。そうでないなら保存処理はされず、エラーが発生している要素にスクロールされる。
      if (!success) {
        const el = document.querySelector('#error:first-of-type');
        el.scrollIntoView({block: 'center', inline: 'nearest'});
      } else {
        // 保存確認ダイアログを表示
        let confirmMessage = [];
        confirmMessage.push(this.$createElement('div','入力された電子書類を登録します。'));
        confirmMessage.push(this.$createElement('div','よろしいですか？'));
        let retConfirm = await this.$bvModal.msgBoxConfirm(confirmMessage, {title: '保存確認'});
        if (retConfirm == true) {
          this.$store.commit('setLoading', true);
          try {
            // 重複チェック
            let errMessage = await this.checkDuplicate();
            if (errMessage == '') {
              // データの登録(SQLの作成)
              if (await this.execSave() == true) {
                // 検索画面に戻る
                this.$router.push({name: 'SAVE-DOCUMENTS-MAINTENANCE-LIST', query: { parentKbn: 1 }});
              }
            } else {
              this.alertWarning.push(errMessage);
            }
          } catch(error) {
            await addOperationLogs('Error', MODULE_NAME, functionName, {}, error);
            console.log(error);
            this.alertDanger.push(DISP_MESSAGES.DANGER['3005']);
          }
          // メッセージが１件でもある場合は一番上へスクロール
          if (this.getMessageFlg == true) {
            scrollTo(0,0);
          }
          this.$store.commit('setLoading', false);
        }
      }
    },
    // 保存実行
    async execSave() {
      const functionName = 'execSave';
      let transactSqlList = [];
      // 電子書類マスタの登録
      transactSqlList.push(await this.insertElectronicDocumentsMaste());

      //console.log(this.transactSqlList);

      // 月次更新・取引先コード切替・製品コード切替などが実行中かどうかを確認します。
      try {
        const msg = await isSystemEditable();
        if (msg !== null) {
          this.alertDanger.push(msg);
          return false;
        }
      } catch (error) {
        await addOperationLogs('Error', MODULE_NAME, functionName, '予期しないエラーが発生しました。', error);
        this.alertDanger.push(DISP_MESSAGES.DANGER['3001']);
        return false;
      }
      // 作成した登録用SQLを全実行
      if (await executeTransactSqlList(transactSqlList, MODULE_NAME, functionName) == false) {
        this.alertDanger.push(DISP_MESSAGES.DANGER['3001']);
        return false;
      }

      return true;
    },
    // 電子書類マスタ登録SQL作成
    async insertElectronicDocumentsMaste() {
      //console.log('電子書類マスタ登録SQL作成');
      let colList = [];
      // 電子書類区分
      colList.push(CreateColRow('electronic_documents_class', this.electronicDocumentsClass, 'NUMBER'));
      // 電子書類名
      colList.push(CreateColRow('electronic_documents_name', await escapeQuote(this.electronicDocumentsName), 'VARCHAR'));
      // 表示順
      colList.push(CreateColRow('sort', this.sort,'NUMBER'));
      // 削除フラグ
      colList.push(CreateColRow('is_deleted', '0','NUMBER'));
      // 作成ユーザー
      colList.push(CreateColRow('created_user', this.loginId, 'VARCHAR'));
      // 更新ユーザー
      colList.push(CreateColRow('updated_user', this.loginId, 'VARCHAR'));
      return CreateInsertSql(colList, 'full', 'm_electronic_documents');
    },
    // 電子書類区分設定
    async setElectronicDocumentsClass() {
      const functionName = 'setElectronicDocumentsClass';
      try {
        this.$store.commit('setLoading', true);
        let selectSql = '';
        selectSql += 'SELECT ';
        selectSql += 'MIN(m_ed.electronic_documents_class) electronic_documents_class';
        selectSql += ' FROM ';
        selectSql += 'm_electronic_documents AS m_ed ';
        selectSql += ' WHERE ';
        selectSql += 'm_ed.electronic_documents_class + 1 NOT IN (SELECT electronic_documents_class FROM m_electronic_documents) ';
        let resultData = await executeSelectSql(selectSql);
        if (resultData != null && resultData.length > 0) {
          this.electronicDocumentsClass = (resultData[0].electronic_documents_class + 1).toString();
        } else {
          // 取得件数が0件の場合は1を設定
          this.electronicDocumentsClass = '1';
        }
      } catch(error) {
        await addOperationLogs('Error', MODULE_NAME, functionName, {}, error);
        console.log(error);
        this.alertDanger.push(DISP_MESSAGES.DANGER['3005']);
      }
      this.$store.commit('setLoading', false);
    },
    // 重複チェックを行う（返却値はエラーメッセージ（空白の場合はエラー無し））
    async checkDuplicate() {
      let selectSql = '';
      selectSql += 'SELECT ';
      selectSql += 'm_ed.electronic_documents_class';
      selectSql += ',m_ed.electronic_documents_name';
      selectSql += ' FROM ';
      selectSql += 'm_electronic_documents AS m_ed ';
      selectSql += ' WHERE ';
      selectSql += 'm_ed.electronic_documents_class = ' + this.electronicDocumentsClass + ' ';
      selectSql += 'OR m_ed.electronic_documents_name = \'' + await escapeQuote(this.electronicDocumentsName) + '\' ';
      let resultData = await executeSelectSql(selectSql);
      if (resultData != null && resultData.length > 0) {
        // 重複データあり
        let isClassDuplicate = false;
        let isNameDuplicate = false;
        // 電子書類区分の重複チェック
        let classIndex = resultData.findIndex(el => el.electronic_documents_class == this.electronicDocumentsClass);
        if (classIndex != -1) {
          isClassDuplicate = true;
        }
        // 電子書類名の重複チェック
        let nameIndex = resultData.findIndex(el => el.electronic_documents_name == this.electronicDocumentsName);
        if (nameIndex != -1) {
          isNameDuplicate = true;
        }
        if (isClassDuplicate == true && isNameDuplicate == true) {
          // 両方重複していた場合
          return DISP_MESSAGES.WARNING['2066'].replace('%arg1%', '電子書類区分').replace('%arg2%', '電子書類名');
        } else if (isClassDuplicate == true) {
          // 電子書類区分が重複していた場合
          return DISP_MESSAGES.WARNING['2076'].replace('%arg1%', '電子書類区分');
        } else {
          // 電子書類名が重複していた場合
          return DISP_MESSAGES.WARNING['2076'].replace('%arg1%', '電子書類名');
        }
      } else {
        // 重複データがないためOK
        return '';
      }
    },
  }
}
</script>
<style scoped>
</style>